<template>
  <div class="main">

    <v-row>
      <v-col cols="12" sm="6" md="4">
        <BasicDialog :width="'w-100 w-sm-67 w-md-50 w-lg-33'">

          <v-row>

            <v-col cols="12" class="d-flex flex-row justify-center align-center">
              <logo-background></logo-background>
              <div style="position: absolute;" class="d-flex flex-row justify-center align-center">
                <img :src="getImage()" alt="Share on Messenger"
                :style="isNetworkImg ? 'width: 200px; height: auto;' : 'width: 80px; height: auto;'">
              </div>
            </v-col>

            <v-col cols="12" class="d-flex flex-row justify-center text-center text-h5 font-weight-bold">
              {{ setSelectedEarnData.offer ? setSelectedEarnData.offer.name : setSelectedEarnData.earn_option.name }}
            </v-col>


            <v-col cols="12" class="text-center">
              You have earned {{ setSelectedEarnData.coins_amount }} coins by {{ setSelectedEarnData.earn_option.name }}
            </v-col>

            <v-col cols="12" class="d-flex flex-row justify-center">
              <v-btn rounded="pill" disabled
                class="  button--secondary text-h6 font-weight-medium pl-6 pr-6 py-6 d-flex">
                <template v-slot:prepend>
                  <v-icon>
                    <coin-big></coin-big>
                  </v-icon>
                </template>
                + {{ setSelectedEarnData.coins_amount }} Claimed
              </v-btn>
            </v-col>


          </v-row>
        </BasicDialog>
      </v-col>
    </v-row>

  </div>




</template>



<script>

import { computed } from "vue";
import CoinBig from "@/icons/CoinBig.vue";
import { AppConfigs } from "@/app.configs";
import LogoBackground from "@/icons/LogoBackground.vue";
import { UserActivityStore } from "@/store/UserActivityStore";
import BasicDialog from "@/components/Common/Basic-Dialog.vue";
import { InHouseTaskMapping } from "@/constants/InHouseTaskMapping";
import { NETWORK_DATA } from "@/constants/Networks/NetworkData";


export default {
  name: "MyEarningDialog",
  components: {
    BasicDialog,
    LogoBackground,
    CoinBig
  },
  setup(props) {

    const inHouseTasksStore = UserActivityStore();

    const setSelectedEarnData = computed(() => {
      return inHouseTasksStore.selectedEarnData;
    });

    return {
      AppConfigs,
      inHouseTasksStore,
      setSelectedEarnData,
    };
  },
  methods: {
    getImage() {
      if (this.setSelectedEarnData.earn_option.type === 'in-house') {
        return InHouseTaskMapping[this.setSelectedEarnData.earn_option.name]?.image ?? "";
      } else {
        return this.setSelectedEarnData.offer ? this.setSelectedEarnData.offer.icon : NETWORK_DATA[this.setSelectedEarnData.earn_option.network_id].image;
      }
    },
  },

  computed: {
  isNetworkImg() {
    return this.setSelectedEarnData.earn_option.type !== 'in-house' && this.setSelectedEarnData.offer === null;
    },
  },
};
</script>